export const TUTORIAL_KEYNAME_LOCAL_STORAGE= 'workflow_creation_tutorial';